module.exports = __webpack_public_path__ + "static/img/emoji.545b3215.png";